module.exports = __webpack_public_path__ + "img/quote1.5dacc18e.jpg";